<h2 md-dialog-title>Data Tagging</h2>
<div class="form">
  <md-dialog-content>
    <div class="row">
      <div class="col-md-4">
        <mat-label class="label-input pull-right">Load Name</mat-label>
      </div>
      <div class="col-md-6">
        <mat-form-field>
          <input
            matInput
            name="loadName"
            [(ngModel)]="tagParameters.loadName"
            #loadName="ngModel"
            readonly
          />
        </mat-form-field>
      </div>
    </div>
    <div class="row">
      <div class="col-md-4">
        <mat-label class="label-input pull-right">Time</mat-label>
      </div>
      <div class="col-md-6">
        <mat-form-field>
          <input
            matInput
            name="time"
            [(ngModel)]="tagParameters.time"
            #time="ngModel"
            readonly
            style="background-color: #57af5b; color: #000000; font-weight: bold"
          />
        </mat-form-field>
      </div>
    </div>
    <div class="row">
      <div class="col-md-4">
        <mat-label class="label-input pull-right">Parameter Name</mat-label>
      </div>
      <div class="col-md-6">
        <mat-form-field>
          <input
            matInput
            name="paramName"
            [(ngModel)]="tagParameters.paramName"
            #paramName="ngModel"
            readonly
          />
        </mat-form-field>
      </div>
    </div>
    <div class="row">
      <div class="col-md-4">
        <mat-label class="label-input pull-right">Parameter Value</mat-label>
      </div>
      <div class="col-md-6">
        <mat-form-field>
          <input
            matInput
            name="paramDisplayValue"
            [(ngModel)]="tagParameters.paramDisplayValue"
            #paramDisplayValue="ngModel"
            readonly
          />
        </mat-form-field>
      </div>
    </div>
    <div class="row">
      <mat-tab-group (selectedTabChange)="onSelectedTab($event)">
        <mat-tab label="Add New DataTag">
          <form
            [formGroup]="formdata"
            #formDirective="ngForm"
            (ngSubmit)="submit()"
            novalidate
          >
            <div>
              <div class="col-md-4">
                <mat-label class="label-input pull-right">Type</mat-label>
              </div>
              <div class="col-md-6">
                <mat-form-field>
                  <mat-select
                    [(ngModel)]="tagParameters.tagType"
                    formControlName="tagTypeCtr"
                    required
                  >
                    <mat-option>Select a Tag Type</mat-option>
                    <mat-option value="Sporadic Event"
                      >Sporadic Event</mat-option
                    >
                    <mat-option value="Start Event" disabled
                      >Start Event (Coming Soon)</mat-option
                    >
                    <mat-option value="End Event" disabled
                      >End Event (Coming Soon)</mat-option
                    >
                  </mat-select>
                  <mat-error *ngIf="isFieldHasError('tagTypeCtr', 'required')"
                    >Please select a tag type.</mat-error
                  >
                </mat-form-field>
              </div>
            </div>
            <div>
              <div class="col-md-4">
                <mat-label class="label-input pull-right">Desciption</mat-label>
              </div>
              <div class="col-md-6">
                <mat-form-field>
                  <textarea
                    [(ngModel)]="tagParameters.tagDescription"
                    matInput
                    formControlName="tagDescCtr"
                    required
                  ></textarea>
                  <mat-error *ngIf="isFieldHasError('tagDescCtr', 'required')"
                    >This field is required.</mat-error
                  >
                  <mat-error *ngIf="isFieldHasError('tagDescCtr', 'maxlength')">
                    Please provide comment up to 50 Characters.
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
            <div>
              <div class="col-md-4">
                <mat-label class="label-input pull-right">&nbsp;</mat-label>
              </div>
              <div class="col-md-6">
                <button
                  type="submit"
                  [disabled]="!formdata.valid"
                  mat-raised-button
                >
                  Add Tag
                </button>
              </div>
            </div>
          </form>
        </mat-tab>
        <mat-tab label="Existing DataTags">
          <mat-table #table [dataSource]="tagData">
            <ng-container matColumnDef="dataTagID">
              <mat-header-cell *matHeaderCellDef> Tag ID</mat-header-cell>
              <mat-cell *matCellDef="let element">
                {{ element.dataTagID }}</mat-cell
              >
            </ng-container>
            <ng-container matColumnDef="tagType">
              <mat-header-cell *matHeaderCellDef> Tag Type</mat-header-cell>
              <mat-cell *matCellDef="let element">
                {{ element.tagType }}</mat-cell
              >
            </ng-container>
            <ng-container matColumnDef="tagDescription">
              <mat-header-cell *matHeaderCellDef>
                Tag Description</mat-header-cell
              >
              <mat-cell *matCellDef="let element">
                {{ element.tagDescription }}</mat-cell
              >
            </ng-container>
            <ng-container matColumnDef="tagValid">
              <mat-header-cell *matHeaderCellDef> Valid Tag?</mat-header-cell>
              <mat-cell *matCellDef="let element">
                {{ element.tagValid }}</mat-cell
              >
            </ng-container>
            <ng-container matColumnDef="taggedBy">
              <mat-header-cell *matHeaderCellDef> Tagged By</mat-header-cell>
              <mat-cell *matCellDef="let element">
                {{ element.taggedBy }}</mat-cell
              >
            </ng-container>
            <ng-container matColumnDef="modifiedTime">
              <mat-header-cell *matHeaderCellDef>
                Last Modified Time</mat-header-cell
              >
              <mat-cell *matCellDef="let element">
                {{ element.modifiedTime }}</mat-cell
              >
            </ng-container>
            <mat-header-row
              *matHeaderRowDef="displayedColumns"
            ></mat-header-row>
            <mat-row
              *matRowDef="let element; columns: displayedColumns"
            ></mat-row>
            -->
          </mat-table>
          <mat-paginator
            #paginator
            [pageSize]="10"
            [pageSizeOptions]="[5, 10, 20]"
          >
          </mat-paginator>
        </mat-tab>
      </mat-tab-group>
    </div>
    <div class="row pull-right">
      <div class="col-md-12 pull-right">
        <button
          type="button"
          mat-button
          (click)="closeDialog(); $event.preventDefault()"
        >
          Close
        </button>
      </div>
    </div>
  </md-dialog-content>
</div>
